var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6,12.8l2.2-2.2c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6l-2.2-2.2 C10.4,7.1,10.2,7,10,7C9.8,7,9.6,7.1,9.4,7.3C9.3,7.4,9.2,7.6,9.2,7.8c0,0.2,0.1,0.4,0.2,0.6l0.8,0.8H7.5C7.2,9.2,7,9.2,6.9,9.4 C6.7,9.6,6.7,9.8,6.7,10c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2h2.7l-0.8,0.8c-0.2,0.2-0.2,0.3-0.2,0.6 c0,0.2,0.1,0.4,0.2,0.6C9.6,12.9,9.8,13,10,13C10.2,13,10.4,12.9,10.6,12.8z M10,18.3c-1.2,0-2.2-0.2-3.2-0.7c-1-0.4-1.9-1-2.6-1.8 s-1.3-1.6-1.8-2.6c-0.4-1-0.7-2.1-0.7-3.2c0-1.2,0.2-2.2,0.7-3.3s1-1.9,1.8-2.6s1.6-1.3,2.6-1.8c1-0.4,2.1-0.7,3.2-0.7 c1.2,0,2.2,0.2,3.3,0.7s1.9,1,2.6,1.8s1.3,1.6,1.8,2.6s0.7,2.1,0.7,3.3c0,1.2-0.2,2.2-0.7,3.2c-0.4,1-1,1.9-1.8,2.6 s-1.6,1.3-2.6,1.8S11.2,18.3,10,18.3z M10,16.7c1.8,0,3.4-0.6,4.7-1.9s1.9-2.9,1.9-4.7c0-1.8-0.6-3.4-1.9-4.7S11.8,3.3,10,3.3 S6.6,4,5.3,5.3C4,6.6,3.3,8.2,3.3,10c0,1.8,0.6,3.4,1.9,4.7C6.6,16,8.2,16.7,10,16.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/ArrowCircleRight.3aa37b35f7e93206509f4ed0231bc575.svg";
export { ForwardRef as ReactComponent };